import { createSlice } from '@reduxjs/toolkit'
import { SceneState } from './types'
import { fetchDashScene, fetchSceneById } from './sceneThunk'

const initialState: SceneState = {
  data: null,
  loading: false,
  error: null,
}

const sceneSlice = createSlice({
  name: 'scene',
  initialState,
  reducers: {
    clearScene: (state) => {
      state.data = null
      state.error = null
      state.loading = false
    },
  },
  extraReducers: (builder) => {
    builder
      // Scene
      .addCase(fetchSceneById.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchSceneById.fulfilled, (state, action) => {
        state.loading = false
        state.data = action.payload.scene
      })
      .addCase(fetchSceneById.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
        state.data = null
      })
      // Dash Scene
      .addCase(fetchDashScene.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchDashScene.fulfilled, (state, action) => {
        state.loading = false
        state.data = action.payload?.scene || null
      })
      .addCase(fetchDashScene.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
        state.data = null
      })
  },
})

export const { clearScene } = sceneSlice.actions

export default sceneSlice.reducer
